import React from 'react'
import { message } from 'hljd'
import style from './style.module.less'
import Upload from '@common/Upload'
import { isStoreAccount } from '@util'

const uploadProps = {
  clipabled: true,
  target: '_self',
  showDelete: true,
  max_file_size: '10mb',
  filters: {
    mime_types: [
      {
        title: 'images files',
        extensions: 'jpg,gif,png,jpeg,bmp'
      }
    ]
  }
}
const PreviewInfomation = (result, type) => {
  /**
   * posterType 套餐15，案例14，套餐列表39，私信99
   */
  switch (type) {
    case 15:
      return (
        <dl className={style.setMealInfo}>
          <dt>
            <img src={result.cover_path + '?imageView2/1/w/100/h/62'} />
          </dt>
          <dd>
            <p>{result.title}</p>
            <p>
              <em>{result.show_price}</em>
              <i className="hlj-gray1">{result.sale_price}</i>
            </p>
          </dd>
        </dl>
      )
    case 14:
      return (
        <dl className={style.setMealInfo}>
          <dt>
            <img src={result.cover_path + '?imageView2/1/w/100/h/62'} />
          </dt>
          <dd>
            <p>{result.title}</p>
          </dd>
        </dl>
      )
    case 267:
      return (
        <a className={style.listBox}>
          {isStoreAccount() ? '新商品管理' : '套餐列表'}
        </a>
      )
    case 99:
      return <a className={style.talkBox}>私信</a>
  }
}

/**
 * @func 上传后校验
 * @param file 文件
 */
const validate = file => {
  let MAX_SIZE = 10 // 最大上传大小，单位 M
  if (file.type.indexOf('/gif') > -1) {
    MAX_SIZE = 2
  }
  const isJudged = file.size / 1024 / 1024 <= MAX_SIZE
  if (!isJudged) {
    message.error(`上传该图片类型大小不能超过${MAX_SIZE}M,请重新上传`)
    return false
  } else {
    return true
  }
}

export default ({
  axis,
  aspect,
  sizeText,
  uploadLink,
  onDelete,
  onOk,
  onCliped,
  onChange,
  haveContent,
  targetResult,
  targetType
}) => (
  <div>
    <div className={style.formItem}>
      <label>
        <i>*</i>橱窗图片
      </label>
      <div className={style.formImg}>
        <p className={style.tip}>
          推荐尺寸：<i>{sizeText}</i>，支持JGP、PNG格式和BMP等大部分格式，图片大小不超过10M,其中GIF类型大小不超过2M
        </p>
        <div>
          <Upload
            isShowCancel={false}
            aspect={aspect}
            onCliped={onCliped(axis)}
            onDelete={onDelete(axis)}
            link={uploadLink}
            validate={validate}
            onOk={onOk(axis)}
            autoSizeError={true}
            {...uploadProps}
          />
        </div>
      </div>
    </div>
    <div className={style.formItem}>
      <label className={style.spec}>
        <i>*</i>跳转结果
      </label>
      <div className={style.formSpec}>
        {!Object.keys(targetResult || {}).length ? (
          <a onClick={onChange(axis)} className={style.blue1}>
            选择
          </a>
        ) : (
          <div className={style.setMealInfoBox}>
            {PreviewInfomation(targetResult, targetType)}
            <a className={style.change} onClick={onChange(axis)}>
              更换
            </a>
          </div>
        )}
      </div>
    </div>
  </div>
)
